import { render, staticRenderFns } from "./MergeCompanyEinModal.vue?vue&type=template&id=991610d8&scoped=true&"
import script from "./MergeCompanyEinModal.vue?vue&type=script&lang=ts&"
export * from "./MergeCompanyEinModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991610d8",
  null
  
)

export default component.exports